import { Component, inject, OnInit, OnDestroy, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TotalProductsSoldType } from 'src/app/models/core/product.model';
import { ProductDetailsModalStateService } from 'src/app/services/modals/product-details-modal-state.service';
import { DirectSaleProductService } from 'src/app/services/product/direct-sale-product.service';
import { SelectionStateService } from 'src/app/services/selection-state.service';
import { formatCommission } from 'src/app/utils/product-details';

@Component({
  selector: 'app-product-details-modal',
  templateUrl: './product-details-modal.component.html',
  styleUrls: ['./product-details-modal.component.scss'],
  standalone: false
})
export class ProductDetailsModalComponent implements OnInit, OnDestroy {
  @Input() isProductExclusivePromotional: boolean = false;
  private state = inject(ProductDetailsModalStateService);
  private selectionState = inject(SelectionStateService);
  @Input() showProgressBar: boolean = false;


  imageError = false;
  swiperInitialized = false;

  constructor(
    private _translate: TranslateService,
    private directSaleService: DirectSaleProductService,
  ) { }


  ngOnInit() {
    setTimeout(() => {
      this.initializeSwiper();
    }, 100);
  }

  ngOnDestroy() {
    this.swiperInitialized = false;
  }

  initializeSwiper() {
    try {
      setTimeout(() => {
        const swiperContainer = document.querySelector('.product-swiper') as any;
        if (swiperContainer && !this.swiperInitialized) {
          const rect = swiperContainer.getBoundingClientRect();
          if (rect.width > 0 && rect.height > 0) {
            if (swiperContainer.swiper) {
              swiperContainer.swiper.update();
            }
            this.swiperInitialized = true;
          } else {
            setTimeout(() => {
              this.initializeSwiper();
            }, 100);
          }
        }
      }, 50);
    } catch (error) {
      console.warn('Error al inicializar swiper:', error);
      setTimeout(() => {
        this.initializeSwiper();
      }, 200);
    }
  }

  trackByImage(index: number, image: string): string {
    return image;
  }

  onImageLoad() {
    setTimeout(() => {
      this.initializeSwiper();
    }, 50);
  }

  onClose() {
    this.state.close();
  }

  get isAdmin(): boolean {
    return this.selectionState.getSelectedRoleValue() === 'administrator';
  }

  get showSalePeriod(): boolean {
    return (
      this.isAdmin &&
      !!this.product?.sale_initial_date &&
      !!this.product?.sale_finish_date
    );
  }

  get showMinAge(): boolean {
    return !!this.product?.min_age && this.product.min_age !== 0;
  }

  get initialBreakpoint(): number {
    const hasImage = this.product?.image && !this.imageError;
    return hasImage ? 0.9 : 0.75;
  }

  get isOpen() {
    return this.state.isOpen();
  }

  get product() {
    return this.state.product();
  }

  get isRestricted(): boolean {
    return this.product?.restricted === 1;
  }

  get formattedCommission(): string | null {
    return this.product ? formatCommission(this.product) : null;
  }

  get productImages(): string[] {
    return this.product?.image ? [this.product.image] : [];
  }

  get toleranceText(): string {
    const tolerance = this.product?.tolerance;

    if (tolerance == null) {
      return this._translate.instant('detail-product.no_tolerance');
    }

    return `${tolerance} ${this._translate.instant('detail-product.minutes')}`;
  }

  get translatedPaymentMethods(): string {
    if (!this.product?.ecommerce || !this.product?.ecommerce_payment_method) {
      return '';
    }

    let methods: string[] = [];

    try {
      methods = JSON.parse(this.product.ecommerce_payment_method);
    } catch (error) {
      console.warn('Error al parsear ecommerce_payment_method', error);
      return this._translate.instant('payment-methods.unknown');
    }

    if (!Array.isArray(methods)) return this._translate.instant('payment-methods.unknown');

    return methods
      .map(method => this._translate.instant(`payment-methods.${method}`) || '')
      .join(' / ');
  }

  get totalProductsSoldType(): TotalProductsSoldType {
    return this.directSaleService.totalProductsSoldType();
  }

}
